import React from 'react';
import { secondary } from '../../assets/strings/variables';
import { NavLink } from 'react-router-dom';
import Monitor from '../../assets/icons/Monitor';
import Phone from '../../assets/icons/Phone';
import Robot from '../../assets/icons/Robot';

const ourSolutionsData = [
  {
    icon: <Monitor />,
    title: 'Pengembangan Website',
    desc: 'Kami memahami bahwa setiap bisnis memiliki keunikan tersendiri. Solusi AI kami dirancang dengan cermat untuk memenuhi kebutuhan spesifik Anda, memastikan dampak dan nilai maksimal.',
  },
  {
    icon: <Phone />,
    title: 'Pengembangan Aplikasi Mobile',
    desc: 'Tim kami terdiri dari pakar AI terkemuka di industri, ilmuwan data, dan insinyur dengan rekam jejak implementasi AI yang sukses di berbagai sektor, seperti keuangan, kesehatan, ritel, dan manufaktur.',
  },
  {
    icon: <Robot />,
    title: 'Pengembangan Kecerdasan Buatan (AI)',
    desc: 'Kami mengembangkan sistem AI yang tidak hanya kuat dan efisien, tetapi juga skalabel. Baik Anda sebuah startup maupun perusahaan besar, solusi kami berkembang seiring dengan bisnis Anda, menyesuaikan dengan peningkatan kebutuhan dan kompleksitas.',
  },
];

function OurSolution() {
  return (
    <section
      id='our-solution'
      className='h-full grid grid-cols-1 px-6 sm:px-10 xl:px-0 max-w-[1200px] w-full py-14 sm:py-20  m-auto'
    >
      <div className='text-[32px] text-center font-semibold '>Solusi Kami</div>
      <div className='grid md:grid-cols-3 gap-6 mt-10'>
        {ourSolutionsData?.map((item, i) => (
          <div key={i} className='p-6'>
            <div>{item.icon}</div>
            <div className='py-2 text-[24px] font-semibold'>{item.title}</div>
            <div className='text-md text-[#898989]'>{item.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default OurSolution;
